"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StackView = _interopRequireDefault(require("../../StackView"));
var _CarouselContext = require("../CarouselContext");
var _CarouselTabsPanelItem = _interopRequireDefault(require("./CarouselTabsPanelItem"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectTabPanelStyle = () => ({
  backgroundColor: 'transparent'
});
const CarouselTabsPanel = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    items
  } = _ref;
  const {
    activeIndex,
    goTo
  } = (0, _CarouselContext.useCarousel)();
  const nextFocusRef = _react.default.useRef();
  const firstTabRef = _react.default.useRef();
  const [isInverse, setIsInverse] = _react.default.useState(false);
  const lastTabSelected = activeIndex === items.length - 1;

  // Get current select tab style
  _react.default.useEffect(() => {
    const [selectedVariantIsInverse] = items.filter((_, index) => index === activeIndex);
    setIsInverse(selectedVariantIsInverse?.inverse);
  }, [items, activeIndex]);

  // TODO: figure out a better cross-brand way to specify subcomponent variants.
  // For now, this picks an Allium variant, and does nothing in brands that lack it.
  // See similar comment in Carousel and https://github.com/telus/universal-design-system/issues/1549
  const dividerVariant = {
    decorative: true,
    inverse: isInverse
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
    style: selectTabPanelStyle(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.default, {
      direction: "row",
      space: 3,
      divider: {
        variant: dividerVariant,
        accessibilityRole: 'presentation',
        accessibilityOrientation: null
      },
      ref: ref,
      accessibilityRole: "tablist",
      children: items.map((_ref2, index) => {
        let {
          title,
          onPress,
          inverse,
          ...panelItemProps
        } = _ref2;
        const selected = index === activeIndex;
        const isNext = index === activeIndex + 1;

        // Selected item should be always unfocusable and unpressable
        const handlePress = selected ? undefined : event => {
          if (typeof onPress === 'function') onPress(event, index);
          goTo(index);
        };
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarouselTabsPanelItem.default, {
          ref: isNext && nextFocusRef || index === 0 && firstTabRef || null,
          title: title,
          selected: selected,
          onPress: handlePress,
          variant: {
            inverse: isInverse
          },
          ...panelItemProps
        }, title);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      focusable: true,
      accessible: true,
      ref: lastTabSelected ? nextFocusRef : null
    })]
  });
});
CarouselTabsPanel.displayName = 'CarouselTabsPanel';
CarouselTabsPanel.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_CarouselTabsPanelItem.default.propTypes || {})),
  // Color defined by `Carousel.item` variant otherwise fallback to transparent
  contentBackgroundColor: _propTypes.default.string
};
var _default = exports.default = CarouselTabsPanel;